export default "__VITE_ASSET__Gxwugdoy__"